import { makeStyles } from '@material-ui/core/styles';
const useStyles = makeStyles(({ palette, variables }) => ({
    tutorialImage:{
        backgroundColor:palette.jet?.supportBrand03,
        marginBottom:variables?.spacingC
    },
    tutorialTitle:{
        marginBottom: variables?.spacingA
    },
    closeButton:{
        marginTop:variables?.spacingC,
        marginBottom:variables?.spacingA,
        float:'right',
    }
}
));

export default useStyles;
